/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Label_ResumeInputs */

const en_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const de_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const fr_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const es_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const it_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const nl_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const pl_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const fi_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const da_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

const sv_story_bank_label_resume = /** @type {(inputs: Story_Bank_Label_ResumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resume`)
};

/**
* | output |
* | --- |
* | "Resume" |
*
* @param {Story_Bank_Label_ResumeInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_label_resume = /** @type {((inputs?: Story_Bank_Label_ResumeInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Label_ResumeInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_label_resume(inputs)
	if (locale === "fr") return fr_story_bank_label_resume(inputs)
	if (locale === "es") return es_story_bank_label_resume(inputs)
	if (locale === "it") return it_story_bank_label_resume(inputs)
	if (locale === "nl") return nl_story_bank_label_resume(inputs)
	if (locale === "pl") return pl_story_bank_label_resume(inputs)
	if (locale === "fi") return fi_story_bank_label_resume(inputs)
	if (locale === "da") return da_story_bank_label_resume(inputs)
	if (locale === "sv") return sv_story_bank_label_resume(inputs)
	return en_story_bank_label_resume(inputs)
});